export const NAVIGATION = [
  {
    Oid: "d62445d9-a24d-4396-9a14-70f73a135532",
    ItemCode: "P0009",
    text: "Default",
    textVi: "Mặc định",
    textJa: "デフォルト",
    path: "/default",
    icon: "/assets/icons/default.svg",
    items: [
      {
        Oid: "8a5a2272-a80c-4b86-9eb7-b164d1637098",
        ItemCode: "P0002",
        text: "Home",
        textVi: "Trang chủ",
        textJa: "Home",
        path: "/scheduler-event/list",
        icon: "",
      },
      {
        Oid: "8a5a2272-a80c-4b86-9eb7-b164d1637098",
        ItemCode: "P0033",
        text: "Scheduler Event",
        textVi: "Lịch sự kiện",
        textJa: "スケジューライベント",
        path: "/scheduler-event/list",
        icon: "",
      },
      {
        Oid: "c4ed8b81-433f-4c5b-a8bb-793efd8bfd44",
        ItemCode: "P0003",
        text: "Announcement",
        textVi: "Thông báo",
        textJa: "アナウンス",
        path: "/announcement/list",
        icon: "",
      },
      {
        Oid: "618214ab-9dc1-493d-a3dd-d2c6dc5a377c",
        ItemCode: "P0027",
        text: "Payslip",
        textVi: "Phiếu lương",
        textJa: "給与明細",
        path: "/payslip/list",
        icon: "",
      },
      {
        Oid: "eeaac380-61c3-49bb-8d82-bc5214cb2c7a",
        ItemCode: "P0029",
        text: "Personal Information",
        textVi: "Thông tin cá nhân",
        textJa: "個人情報",
        path: "/personal-information",
        icon: "",
      },
      {
        Oid: "fc8a9c7f-d544-4879-85d6-75551751ab66",
        ItemCode: "P0010",
        text: "Dictionary",
        textVi: "Từ điển",
        textJa: "辞書",
        path: "/dictionary/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "4d65e369-f517-47ae-bf38-7611037f6203",
    ItemCode: "P0012",
    text: "Leave",
    textVi: "Nghỉ",
    textJa: "休暇",
    path: "/leave",
    icon: "/assets/icons/leave.svg",
    items: [
      {
        Oid: "94010040-abb7-4c90-9278-cfad6d948ef5",
        ItemCode: "P0014",
        text: "Leave Registration",
        textVi: "Đăng ký nghỉ",
        textJa: "休暇登録",
        path: "/leave-registration/list",
        icon: "",
      },
      {
        Oid: "5c0271ea-b035-4350-b749-28f2bb162ab8",
        ItemCode: "P0013",
        text: "Leave Approval",
        textVi: "Phê duyệt đăng ký nghỉ",
        textJa: "休暇承認",
        path: "/leave-approval/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "08baf8b4-97fa-4bd5-badb-a27b73bde4b5",
    ItemCode: "P0020",
    text: "Overtime",
    textVi: "Tăng ca",
    textJa: "残業",
    path: "/overtime",
    icon: "/assets/icons/overtime.svg",
    items: [
      {
        Oid: "cc08aac0-2ac5-42e8-821f-a86d0c787cf8",
        ItemCode: "P0022",
        text: "Overtime Registration",
        textVi: "Đăng ký tăng ca",
        textJa: "残業登録",
        path: "/overtime-registration/list",
        icon: "",
      },
      {
        Oid: "017d3ed5-18a9-454e-a3b2-44e38ecfed1f",
        ItemCode: "P0021",
        text: "Overtime Approval",
        textVi: "Phê duyệt tăng ca",
        textJa: "残業承認",
        path: "/overtime-approval/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "d98207d3-7adc-4a3b-b0ca-e92a98a839a7",
    ItemCode: "P0043",
    text: "Time in-out",
    textVi: "Dữ liệu giờ vào ra",
    textJa: "入る/出る時間",
    path: "/transactions",
    icon: "/assets/icons/transaction.svg",
    items: [
      {
        Oid: "ddd71286-1483-4ac9-967f-ccb9fb7fae67",
        ItemCode: "P0044",
        text: "Time in-out Adjustment",
        textVi: "Điều chỉnh giờ vào ra",
        textJa: "入る/出る時間調整",
        path: "/transactions-adjustment/list",
        icon: "",
      },
      {
        Oid: "9b5b35b4-dba9-4bbb-ad51-b89c3fde7ba9",
        ItemCode: "P0045",
        text: "Time in-out Approval",
        textVi: "Phê duyệt điều chỉnh giờ vào ra",
        textJa: "入る/出る時間調整承認",
        path: "/transactions-adjustment-approval/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "9044369b-cb00-443a-b0dc-28730346d083",
    ItemCode: "P0034",
    text: "TimeKeeping",
    textVi: "Chấm công trực tuyến",
    textJa: "オンライン計時",
    path: "/timekeeping",
    icon: "/assets/icons/timekeeping.svg",
    items: [
      {
        Oid: "429245dd-efa6-49b7-8c4f-35a9ff5b77ae",
        ItemCode: "P0035",
        text: "TimeKeeping Online",
        textVi: "Chấm công trực tuyến",
        textJa: "オンライン計時登録",
        path: "/timekeeping-online/list",
        icon: "",
      },
      {
        Oid: "7cfc6d06-67c5-496d-ae1d-e8f18755156d",
        ItemCode: "P0036",
        text: "TimeKeeping Online Approval",
        textVi: "Phê duyệt chấm công trực tuyến",
        textJa: "オンライン計時承認",
        path: "/timekeeping-online-approval/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "37d36497-dbd3-4001-9196-4809bac8b067",
    ItemCode: "P0004",
    text: "Approval Setting",
    textVi: "Thiết lập phê duyệt",
    textJa: "承認設定",
    path: "/approval",
    icon: "/assets/icons/approval.svg",
    items: [
      {
        Oid: "23378a45-d4a6-4445-a40c-301c97b2d63f",
        ItemCode: "P0005",
        text: "Approval Setting Department",
        textVi: "Thiết lập phê duyệt phòng ban",
        textJa: "承認設定部門",
        path: "/approval-setting-department/list",
        icon: "",
      },
      {
        Oid: "3e6edd95-249e-4af9-b6d9-d0ecfddce89f",
        ItemCode: "P0011",
        text: "Approval Setting Employee",
        textVi: "Thiết lập phê duyệt nhân viên",
        textJa: "承認設定従業員",
        path: "/approval-setting-employee/list",
        icon: "",
      },
    ],
  },
  {
    Oid: "458518f2-6ee7-4fac-9a2d-ac1272d28294",
    ItemCode: "P0028",
    text: "Permission",
    textVi: "Phân Quyền",
    textJa: "許可",
    path: "/permissions",
    icon: "/assets/icons/permission.svg",
    items: [
      {
        Oid: "4925ff6b-b2b2-4ecf-9e78-aa8408652681",
        ItemCode: "P0032",
        text: "Roles",
        textVi: "Vai trò",
        textJa: "役割",
        path: "/roles/list",
        icon: "",
      },
      {
        Oid: "a12a8f38-8cac-46af-b150-55b83aa1a367",
        ItemCode: "P0030",
        text: "Role Details",
        textVi: "Chi tiết vai trò",
        textJa: "役割詳細",
        path: "/role-details/list",
        icon: "",
      },
      {
        Oid: "3100ce8b-4812-4adb-ae44-47007d4d8c74",
        ItemCode: "P0047",
        text: "Users",
        textVi: "Người dùng",
        textJa: "ユーザー",
        path: "/users/list",
        icon: "",
      },
      {
        Oid: "eaf16af3-bd27-484e-95d3-3feb2fb5f23c",
        ItemCode: "P0031",
        text: "Role Users",
        textVi: "Vai trò người dùng",
        textJa: "ロールユーザー",
        path: "/role-users/list",
        icon: "",
      },
    ],
  },
];
